/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { useEffect, useState, useRef, forwardRef, useImperativeHandle } from 'react';
import { useReactToPrint } from 'react-to-print';

// @mui material components
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';

// Material Dashboard 2 PRO React examples
import * as Func from 'services/Function';
import './PointOfSale.css';
import { Box } from '@mui/material';

const PosPrintSurvey = forwardRef((_, ref) => {
  const [list, setList] = useState([]);
  const [isPrinting, setIsPrinting] = useState(false);
  const printRef = useRef(null);
  const promiseResolveRef = useRef(null);
  const [attr, setAttr] = useState({});

  useEffect(() => {
    if (isPrinting && promiseResolveRef.current) {
      promiseResolveRef.current();
    }
  }, [isPrinting]);

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    onBeforeGetContent: () => {
      return new Promise((resolve) => {
        promiseResolveRef.current = resolve;
        setIsPrinting(true);
      });
    },
    onAfterPrint: () => {
      promiseResolveRef.current = null;
      setIsPrinting(false);
      setList([]);
      setAttr({});
    },
  });

  const print = (result) => {
    if (result) {
      setAttr(result);
      setList(result.list);
      handlePrint();
    } else {
      handlePrint();
    }
  };

  const renderContent = () => {
    return (
      <Box sx={{ mx: 2 }}>
        <table width='100%'>
          <tbody>
            <tr>
              <td align='center' colSpan={4}>
                <h3>สาขา {attr.branch}</h3>
              </td>
            </tr>
            <tr>
              <td align='center' colSpan={4}>
                ตรวจนับเงินสด Shift Survey <b>{attr.pos}</b> วันที่ {Func.dateNow()}
              </td>
            </tr>
            <tr>
              <td>
                <p>&nbsp;</p>
              </td>
            </tr>
            <tr>
              <td align='left'>ลิ้นชัก</td>
              <td align='right'>&nbsp;</td>
              <td align='right'>จำนวน</td>
              <td align='right'>รวม</td>
            </tr>
            {list
              .sort((a, b) => a.id - b.id)
              .map((item) => (
                <tr>
                  <td align='left'>{Number(item.price)}</td>
                  <td align='right'>&nbsp;</td>
                  <td align='right'>{item.quantity}</td>
                  <td align='right'>{Func.numberDisplay(item.total, 2)}</td>
                </tr>
              ))}
            <tr>
              <td align='left'>ซองดรอป</td>
              <td align='right'>&nbsp;</td>
              <td align='right' colSpan={2}>
                {Func.numberDisplay(attr.money_drop, 2)}
              </td>
            </tr>
            <tr>
              <td align='left'>นับดรอป</td>
              <td align='right'>&nbsp;</td>
              <td align='right' colSpan={2}>
                {Func.numberDisplay(attr.drop, 2)}
              </td>
            </tr>
            <tr>
              <td align='left'>เงินสด</td>
              <td align='right'>&nbsp;</td>
              <td align='right' colSpan={2}>
                {Func.numberDisplay(attr.wallet, 2)}
              </td>
            </tr>
            <tr>
              <td align='left'>นับเงินสด</td>
              <td align='right'>&nbsp;</td>
              <td align='right' colSpan={2}>
                {Func.numberDisplay(attr.total, 2)}
              </td>
            </tr>
            <tr>
              <td align='left'>ขาดเกิน</td>
              <td align='right'>&nbsp;</td>
              <td align='right' colSpan={2}>
                {Func.numberDisplay(attr.diff, 2)}
              </td>
            </tr>
            <tr>
              <td>
                <p>&nbsp;</p>
              </td>
            </tr>
          </tbody>
        </table>
        <table width='100%'>
          <tbody>
            <tr>
              <td colSpan='2'>
                <p>
                  <br />
                </p>
              </td>
            </tr>
            <tr>
              <td align='right' colSpan={2}>
                ผู้ทำ {attr.user}
              </td>
              <td align='right'>&nbsp;</td>
              <td align='right'>วันที่พิมพ์ &nbsp;{Func.dateTimeNow()}</td>
            </tr>
          </tbody>
        </table>
      </Box>
    );
  };

  const renderPrint = () => {
    return <div>{renderContent()}</div>;
  };

  useImperativeHandle(ref, () => {
    return {
      print,
    };
  });

  return (
    <div style={{ display: 'none' }}>
      <div ref={printRef} className='slip'>
        {list.length > 0 ? renderPrint() : null}
      </div>
    </div>
  );
});

export default PosPrintSurvey;
